/* global window */

import './style.scss';

import React from 'react';
import { connect } from 'react-redux';
import Clipboard from 'clipboard';
import { trackNow } from 'shared/models/analytic';

class SharePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultLink: '',
      facebookLink: null,
      twitterLink: null,
      emailLink: null,
      copiedLink: false,
      twitterIntent: '',
      emailHref: ''
    };
    this.shareFB = this.shareFB.bind(this);
    this.trackTwitterShare = this.trackShare.bind(this, 'twitter');
    this.trackEmailShare = this.trackShare.bind(this, 'email');
  }

  componentDidMount() {
    this._constructLink('link', 'defaultLink');
    this._constructLink('facebook', 'facebookLink', {
      $og_description: this._sanitizeCopy(this.props.copy.share.facebookBody2)
    });
    this._constructLink('twitter', 'twitterLink');
    this._constructLink('email', 'emailLink');

    const clipboard = new Clipboard('#link-copy-btn');
    clipboard.on('success', () => {
      this.setState({ copiedLink: true });
      setTimeout(() => this.setState({ copiedLink: false }), 1000);
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.state.twitterLink &&
      this.state.twitterLink !== prevState.twitterLink
    ) {
      this._setTwitterIntent(this.state.twitterLink);
    }

    if (this.state.emailLink && this.state.emailLink !== prevState.emailLink) {
      this._setEmailHref(this.state.emailLink);
    }
  }

  _sanitizeCopy(str = '', replaceText = '') {
    return str.replace(/%\d\$@/, replaceText).trim(); // remove iOS interpolation placeholder
  }

  _constructLink(channel, stateKey, shareData = {}) {
    const data = {
      ...shareData,
      parse_id: this.props.user.objectId
    };

    if (window.branch) {
      window.branch.link({ feature: 'sharing', channel, data }, (err, link) => {
        if (err) {
          console.log('share link error', err, link); // eslint-disable-line no-console
          return;
        } else {
          this.setState({ [stateKey]: link });
        }
      });
    }
  }

  _setTwitterIntent(url) {
    const text = this._sanitizeCopy(this.props.copy.share.twitterBody2);
    const twitterIntent = encodeURI(
      `https://twitter.com/intent/tweet?text=${text}&url=${url}`
    );
    this.setState({ twitterIntent });
  }

  _setEmailHref(shareLink) {
    const subject = this.props.copy.share.emailSubject2;
    const body = this._sanitizeCopy(
      this.props.copy.share.emailBody2,
      shareLink
    );
    const emailHref = encodeURI(`mailto:?subject=${subject}&body=${body}`);
    this.setState({ emailHref });
  }

  shareFB() {
    if (
      this.state.facebookLink &&
      window.FB &&
      typeof window.FB.ui === 'function'
    ) {
      window.FB.ui(
        { method: 'share', href: this.state.facebookLink },
        response => {
          if (response && response.error_message) {
            console.log('facebook share error', response.error_message); // eslint-disable-line no-console
          }
        }
      );

      this.trackShare('facebook');
    }
  }

  trackShare(type) {
    trackNow('share', { type, parse_id: this.props.user.objectId });
  }

  render() {
    return (
      <div className="share-page banner-padding">
        <div className="share-page__hero">
          <div className="row center-xs">
            <div className="col-xs-12">
              <h1 className="share-page__heading">Give $10 Get $10</h1>
            </div>
            <div className="col-xs-10">
              <div className="invite-link">
                <input
                  aria-label="invite link"
                  className="invite-link__text"
                  id="link-copy-text"
                  type="text"
                  value={this.state.defaultLink}
                  placeholder="Loading..."
                  readOnly
                />
                <button
                  className="btn-small invite-link__btn"
                  id="link-copy-btn"
                  data-clipboard-target="#link-copy-text"
                  disabled={this.state.copiedLink}
                >
                  {this.state.copiedLink ? 'Copied' : 'Copy'}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row center-xs">
          <div className="col-xs-10">
            <p className="share-page__instructions">
              Your friends get a $10 credit, <br className="hidden-sm" />
              and you get $10 after their first delivery.
            </p>
          </div>
        </div>
        <div className="row center-xs">
          <div className="col-xs-12 col-sm-3">
            <button
              className="button button-wide fb-button social-btn"
              onClick={this.shareFB}
            >
              <i className="icon-facebook social-btn__icon" />
              <span>Facebook</span>
            </button>
          </div>
          <div className="col-xs-12 col-sm-3">
            <a
              href={this.state.twitterIntent}
              target="_blank"
              rel="noopener noreferrer"
              className="button button-wide btn-primary social-btn twitter-button"
              onClick={this.trackTwitterShare}
            >
              <i className="icon-twitter social-btn__icon" />
              <span>Twitter</span>
            </a>
          </div>
          <div className="col-xs-12 col-sm-3">
            <a
              href={this.state.emailHref}
              target="_blank"
              rel="noopener noreferrer"
              className="button button-wide btn-primary social-btn"
              onClick={this.trackEmailShare}
            >
              <i className="icon-mail social-btn__icon" />
              <span>Email</span>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.login.user,
    copy: state.app.copy
  };
}

export default connect(
  mapStateToProps,
  {}
)(SharePage);
